import React from "react"
import ReactConfetti from "react-confetti"
import styled from "styled-components"

const ContainerConfetti = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
`
const colors = ["#f56a2c", "#fad600", "#00adee", "#26b4ae"]
const Confetti = () => {
  return (
    <ContainerConfetti>
      <ReactConfetti numberOfPieces={75} gravity={0.04} colors={colors} opacity={0.5} tweenDuration={3000} />
    </ContainerConfetti>
  )
}

export default Confetti
